import React from "react";
import "../styles/home.css";
import Navbar from "../components/Navbar";
import HeroSection from "../components/AboutHerosection";
import AboutSection from "../components/Aboutsection";

const About = () => {
  return (
    <div className="home">
      <Navbar />
      <HeroSection />
      <AboutSection />
    </div>
  );
};

export default About;
